import { render, staticRenderFns } from "./recycleDialog.vue?vue&type=template&id=3dfcdae7&scoped=true"
import script from "./recycleDialog.vue?vue&type=script&lang=js"
export * from "./recycleDialog.vue?vue&type=script&lang=js"
import style0 from "./recycleDialog.vue?vue&type=style&index=0&id=3dfcdae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfcdae7",
  null
  
)

export default component.exports